import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import { Box } from '@mui/material';

const Logo = forwardRef(({ disabledLink = false, sx }, ref) => {
  const logo = (
    <Box
      ref={ref}
      component="img"
      src="/assets/Logo3.png"
      alt="SmartShield Logo"
      sx={{ width: 220, height: 46, cursor: 'pointer', ...sx }}
    />
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <a href="/" aria-label="SmartShield Home" style={{ display: 'contents' }}>
      {logo}
    </a>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
